import * as React from 'react';
import { PickListItem } from './PickList';
import { PickListItemComponent } from './PickListItem';

interface PickListPanelProps<T extends PickListItem> {
  items: T[];
  selectedItems: Set<string>;
  listId: string;
  listRef: React.RefObject<HTMLDivElement | null>;
  header?: React.ReactNode;
  label: string;
  isTarget: boolean;
  itemTemplate: (item: T, isTarget: boolean) => React.ReactNode;
  onItemClick: (itemId: string, event: React.MouseEvent) => void;
}

export function PickListPanel<T extends PickListItem>({
  items,
  selectedItems,
  listId,
  listRef,
  header,
  label,
  isTarget,
  itemTemplate,
  onItemClick,
}: PickListPanelProps<T>) {
  return (
    <div className="bmwe-picklist-panel">
      {header && <div className="bmwe-picklist-header">{header}</div>}
      <div
        ref={listRef}
        id={listId}
        className="bmwe-picklist-list"
        role="listbox"
        aria-label={label}
        aria-multiselectable="true"
        tabIndex={0}
      >
        {items.map((item) => (
          <PickListItemComponent
            key={item.id}
            id={item.id}
            isSelected={selectedItems.has(item.id)}
            onItemClick={onItemClick}
          >
            {itemTemplate(item, isTarget)}
          </PickListItemComponent>
        ))}
      </div>
    </div>
  );
}
